import React from 'react';
import { RhSingleAutocomplete } from '../../../../../../../dum';
import {
    ExpenseResourcesInputQuery,
    useExpenseResourcesInputQuery,
} from '../../../../../../../../services';
import { EXPENSE_RESOURCES, RESOURCE_ID } from '../../expense-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function ResourcesInput({ index }: { index: number }) {
    const { data } = useExpenseResourcesInputQuery();

    const INPUT_NAME = `${EXPENSE_RESOURCES}.${index}.${RESOURCE_ID}`;

    const rawMaterialAdditions: ExpenseResourcesInputQuery['getResources'] =
        data?.getResources ? data?.getResources : [];

    return (
        <RhSingleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            options={rawMaterialAdditions}
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.resource_id)}
            disableGutters
        />
    );
}
